<template>
  <div class="page-header-index-wide">
    <!-- <a-row :gutter="24">
      <a-col :sm="24" :md="12" :xl="6" :style="{ marginBottom: '24px' }">
        <chart-card :loading="loading" title="总销售额" total="￥126,560">
          <a-tooltip title="指标说明" slot="action">
            <a-icon type="info-circle-o" />
          </a-tooltip>
          <div>
            <trend flag="up" style="margin-right: 16px;">
              <span slot="term">周同比</span>
              12%
            </trend>
            <trend flag="down">
              <span slot="term">日同比</span>
              11%
            </trend>
          </div>
          <template slot="footer">日均销售额<span>￥ 234.56</span></template>
        </chart-card>
      </a-col>
      <a-col :sm="24" :md="12" :xl="6" :style="{ marginBottom: '24px' }">
        <chart-card :loading="loading" title="订单量" :total="8846 | NumberFormat">
          <a-tooltip title="指标说明" slot="action">
            <a-icon type="info-circle-o" />
          </a-tooltip>
          <div>
            <mini-area />
          </div>
          <template slot="footer">日订单量<span> {{ '1234' | NumberFormat }}</span></template>
        </chart-card>
      </a-col>
      <a-col :sm="24" :md="12" :xl="6" :style="{ marginBottom: '24px' }">
        <chart-card :loading="loading" title="支付笔数" :total="6560 | NumberFormat">
          <a-tooltip title="指标说明" slot="action">
            <a-icon type="info-circle-o" />
          </a-tooltip>
          <div>
            <mini-bar :height="40" />
          </div>
          <template slot="footer">转化率 <span>60%</span></template>
        </chart-card>
      </a-col>
      <a-col :sm="24" :md="12" :xl="6" :style="{ marginBottom: '24px' }">
        <chart-card :loading="loading" title="运营活动效果" total="78%">
          <a-tooltip title="指标说明" slot="action">
            <a-icon type="info-circle-o" />
          </a-tooltip>
          <div>
            <mini-progress color="rgb(19, 194, 194)" :target="80" :percentage="78" :height="8" />
          </div>
          <template slot="footer">
            <trend flag="down" style="margin-right: 16px;">
              <span slot="term">同周比</span>
              12%
            </trend>
            <trend flag="up">
              <span slot="term">日环比</span>
              80%
            </trend>
          </template>
        </chart-card>
      </a-col>
    </a-row>

    <a-card :loading="loading" :bordered="false" :body-style="{padding: '0'}">
      <div class="salesCard">
        <a-tabs default-active-key="1" size="large" :tab-bar-style="{marginBottom: '24px', paddingLeft: '16px'}">
          <div class="extra-wrapper" slot="tabBarExtraContent">
            <div class="extra-item">
              <a>今日</a>
              <a>本周</a>
              <a>本月</a>
              <a>本年</a>
            </div>
            <a-range-picker :style="{width: '256px'}" />
          </div>
          <a-tab-pane loading="true" tab="销售额" key="1">
            <a-row>
              <a-col :xl="16" :lg="12" :md="12" :sm="24" :xs="24">
                <bar title="销售额排行" :dataSource="barData"/>
              </a-col>
              <a-col :xl="8" :lg="12" :md="12" :sm="24" :xs="24">
                <rank-list title="门店销售排行榜" :list="rankList"/>
              </a-col>
            </a-row>
          </a-tab-pane>
          <a-tab-pane tab="销售趋势" key="2">
            <a-row>
              <a-col :xl="16" :lg="12" :md="12" :sm="24" :xs="24">
                <bar title="销售额趋势" :dataSource="barData"/>
              </a-col>
              <a-col :xl="8" :lg="12" :md="12" :sm="24" :xs="24">
                <rank-list title="门店销售排行榜" :list="rankList"/>
              </a-col>
            </a-row>
          </a-tab-pane>
        </a-tabs>
      </div>
    </a-card> -->
    <div class="wrap" style="background-color: white; padding: 20px 0">
    <a-row>
      <a-col :span="4">
        <head-info title="今日预约访客量" :content="loginfo.todayTotalNum"></head-info>
      </a-col>
      <a-col :span="1">
        <a-spin class="circle-cust">
          <a-icon slot="indicator" type="team" style="font-size: 24px" />
        </a-spin>
      </a-col>
      <a-col :span="4">
        <head-info title="今日到访访客量" :content="loginfo.todayArriveNum"></head-info>
      </a-col>
      <a-col :span="1">
        <a-spin class="circle-cust">
          <a-icon slot="indicator" type="team" style="font-size: 24px" />
        </a-spin>
      </a-col>
      <a-col :span="4">
        <head-info title="本月预约访客量" :content="loginfo.monthTotalNum"></head-info>
      </a-col>
      <a-col :span="1">
        <a-spin class="circle-cust">
          <a-icon slot="indicator" type="team" style="font-size: 24px" />
        </a-spin>
      </a-col>
      <a-col :span="4">
        <head-info title="本月到访访客量" :content="loginfo.monthArriveNum"></head-info>
      </a-col>
      <a-col :span="1">
        <a-spin class="circle-cust">
          <a-icon slot="indicator" type="team" style="font-size: 24px" />
        </a-spin>
      </a-col>
      <!-- <a-col :span="6">
        <head-info title="总访问量" :content="loginfo.totalVisitCount"></head-info>
      </a-col>
      <a-col :span="2">
        <a-spin class="circle-cust">
          <a-icon slot="indicator" type="rise" style="font-size: 24px" />
        </a-spin>
      </a-col> -->
    </a-row>
    </div>
    <a-row>
      <a-col :span="24">
        <a-card :loading="loading">
          <a-row style="margin: 10px 0 50px; padding-bottom: 20px;">
            <div class="topbar">
              <div class="leftTitle">
                <h3>访客近期数据统计</h3>
              </div>
              <div class="button-group" style="position：absolute;top: 0;right: 0">
                <a-range-picker
                  class="range-picker lianedate"
                  @change="changeDate"
                  :value="showDate"
                  :disabledDate="disabledDate"
                >
                  <template slot="renderExtraFooter"></template>
                </a-range-picker>
                <a-button-group>
                  <a-button :type="lineChartChooseTypeOne" @click="chooseButtonOne()">一周</a-button>
                  <a-button :type="lineChartChooseTypeTwo" @click="chooseButtonTwo()">十五天</a-button>
                  <a-button :type="lineChartChooseTypeThree" @click="chooseButtonThree()">一个月</a-button>
                </a-button-group>
              </div>
            </div>
          </a-row>
          <line-chart-multid :fields="visitFields" :aliases="aliases" :dataSource="visitInfo"></line-chart-multid>
        </a-card>
      </a-col>
    </a-row>
    <sms-details></sms-details>
    <sms-details-pie-source></sms-details-pie-source>
    <sms-details-pie-place></sms-details-pie-place>
  </div>
</template>

<script>
import ChartCard from '@/components/ChartCard'
import ACol from 'ant-design-vue/es/grid/Col'
import ATooltip from 'ant-design-vue/es/tooltip/Tooltip'
import MiniArea from '@/components/chart/MiniArea'
import MiniBar from '@/components/chart/MiniBar'
import MiniProgress from '@/components/chart/MiniProgress'
import RankList from '@/components/chart/RankList'
import Bar from '@/components/chart/Bar'
import LineChartMultid from '@/components/chart/LineChartMultid'
import HeadInfo from '@/components/tools/HeadInfo.vue'

import Trend from '@/components/Trend'
import { getAnalysisData, getRealTimeAnalysisData, getSourcePieData} from '@/api/api'

import smsDetails from '../components/smsDashboard/details'
import smsDetailsPieSource from '../components/smsDashboard/detailsPieSource'
import smsDetailsPiePlace from '../components/smsDashboard/detailsPiePlace'
import moment from 'moment'

const rankList = []
for (let i = 0; i < 7; i++) {
  rankList.push({
    name: '白鹭岛 ' + (i + 1) + ' 号店',
    total: 1234.56 - i * 100,
  })
}
const barData = []
for (let i = 0; i < 12; i += 1) {
  barData.push({
    x: `${i + 1}月`,
    y: Math.floor(Math.random() * 1000) + 200,
  })
}
export default {
  name: 'IndexChart',
  components: {
    ATooltip,
    ACol,
    ChartCard,
    MiniArea,
    MiniBar,
    MiniProgress,
    RankList,
    Bar,
    Trend,
    LineChartMultid,
    HeadInfo,
    smsDetails,
    smsDetailsPieSource,
    smsDetailsPiePlace,
  },
  data() {
    return {
      loading: true,
      center: null,
      rankList,
      barData,
      loginfo: {},
      visitFields: ['appointNum', 'temporaryNum', 'arriveNum', 'notArriveNum'],
      // visitFields: ['预约访客', '临时访客', '已到访客', '未到访客'],
      aliases: [{field:'appointNum',alias:'预约访客'}, {field:'temporaryNum',alias:'临时访客'},
          {field:'arriveNum',alias:'已到访客'}, {field:'notArriveNum',alias:'未到访客'}],

      visitInfo: [],
      indicator: <a-icon type="loading" style="font-size: 24px" spin />,
      lineChartChooseTypeOne: '',
      lineChartChooseTypeTwo: '',
      lineChartChooseTypeThree: '',
      lineChartDate: [],
      showDate: [
        moment(moment(new Date()).subtract(2, 'day').format('YYYY-MM-DD'), 'YYYY-MM-DD'),
        moment(moment(new Date()).format('YYYY-MM-DD'), 'YYYY-MM-DD'),
      ],
    }
  },
  mounted() {
    setTimeout(() => {
      this.loading = !this.loading
    }, 1000)
    // this.initLogInfo()
    
    this.chooseButtonOne()
    this.getAllCount()
  },
  methods: {
    // initLogInfo() {
    //   getTodayAnalysisData(null).then((res) => {
    //     if (res.success) {
    //       Object.keys(res.result).forEach((key) => {
    //         res.result[key] = res.result[key] + ''
    //       })
    //       this.loginfo = res.result
    //     }
    //   })
    //   getAnalysisData().then((res) => {
    //     if (res.success) {
    //       this.visitInfo = res.result.reverse()
    //       console.log('res.result',res.result)
    //     }
    //   })
    // },
    disabledDate(current) {
      return current > moment(moment(new Date()).format('YYYY-MM-DD'), 'YYYY-MM-DD')
    },
    chooseButtonOne() {
      this.lineChartChooseTypeOne = 'primary'
      this.lineChartChooseTypeTwo = ''
      this.lineChartChooseTypeThree = ''
      this.lineChartDate[0] = moment(new Date()).subtract(6, 'day').format('YYYY-MM-DD') ? moment(new Date()).subtract(6, 'day').format('YYYY-MM-DD') : ''
      this.lineChartDate[1] = moment(new Date()).format('YYYY-MM-DD') ? moment(new Date()).format('YYYY-MM-DD') : ''
      this.showDate[0] = moment(moment(new Date()).subtract(6, 'day').format('YYYY-MM-DD'), 'YYYY-MM-DD')
      this.showDate[1] = moment(moment(new Date()).format('YYYY-MM-DD'), 'YYYY-MM-DD')
      this.getLineChartDate()
      this.getAllCount()
    },
    chooseButtonTwo() {
      this.lineChartChooseTypeOne = ''
      this.lineChartChooseTypeTwo = 'primary'
      this.lineChartChooseTypeThree = ''
      this.lineChartDate[0] = moment(new Date()).subtract(14, 'day').format('YYYY-MM-DD')
      this.lineChartDate[1] = moment(new Date()).format('YYYY-MM-DD')
      this.showDate[0] = moment(moment(new Date()).subtract(14, 'day').format('YYYY-MM-DD'), 'YYYY-MM-DD')
      this.showDate[1] = moment(moment(new Date()).format('YYYY-MM-DD'), 'YYYY-MM-DD')
      this.getLineChartDate()
      // this.getAllCount()
    },
    chooseButtonThree() {
      this.lineChartChooseTypeOne = ''
      this.lineChartChooseTypeTwo = ''
      this.lineChartChooseTypeThree = 'primary'
      this.lineChartDate[0] = moment(new Date()).subtract(1, 'month').format('YYYY-MM-DD')
      this.lineChartDate[1] = moment(new Date()).format('YYYY-MM-DD')
      this.showDate[0] = moment(moment(new Date()).subtract(1, 'month').format('YYYY-MM-DD'), 'YYYY-MM-DD')
      this.showDate[1] = moment(moment(new Date()).format('YYYY-MM-DD'), 'YYYY-MM-DD')
      this.getLineChartDate()
      // this.getAllCount()
    },
    changeDate(dates, dateStrings) {
      this.showDate = dates
      this.lineChartDate[0] = dateStrings[0]
      this.lineChartDate[1] = dateStrings[1]
      this.lineChartChooseTypeOne = ''
      this.lineChartChooseTypeTwo = ''
      this.lineChartChooseTypeThree = ''
      this.getLineChartDate()
      // this.getAllCount()
    },
    getLineChartDate() {
      console.log(1111111111)
      this.loadingLine = true
      let params = {
        endTime: this.lineChartDate[1],
        startTime: this.lineChartDate[0],
      }
      getAnalysisData(params).then((res) => {
        if (res.success) {
          console.log('initLogInfo',res)
          this.visitInfo = res.result.reverse()
          this.loadingLine = false
        } else {
          // this.chooseButtonOne()
        }
      })
      getSourcePieData(params).then((res) => {
        if (res.success) {
          console.log(res)
          // Object.keys(res.result).forEach((key) => {
          //   res.result[key] = res.result[key] + ''
          // })
          // this.loginfo = res.result
        }
      })
    },
    getAllCount() {
      console.log('getAllCount',111111111111111)
      getRealTimeAnalysisData().then((res) => {
        if (res.success) {
          Object.keys(res.result).forEach((key) => {
            res.result[key] = res.result[key] + ''
          })
          this.loginfo = res.result
        }
      })
      // let params = {
      //   endTime: this.lineChartDate[1],
      //   startTime: this.lineChartDate[0],
      // }
      // allCount(params).then((res) => {
      //   if (res.success) {
      //     this.successCount = res.result.countSuccess
      //     this.errorCouant = res.result.countFail
      //     this.countWait = res.result.countWait
      //   } else {
      //     // this.chooseButtonOne()
      //   }
      // })
    },
  },
}
</script>

<style lang="less" scoped>
.circle-cust {
  position: relative;
  top: 28px;
  left: -100%;
}
.extra-wrapper {
  line-height: 55px;
  padding-right: 24px;

  .extra-item {
    display: inline-block;
    margin-right: 24px;

    a {
      margin-left: 24px;
    }
  }
}

/* 首页访问量统计 */
.head-info {
  position: relative;
  text-align: left;
  padding: 0 32px 0 0;
  min-width: 125px;

  &.center {
    text-align: center;
    padding: 0 32px;
  }

  span {
    color: rgba(0, 0, 0, 0.45);
    display: inline-block;
    font-size: 0.95rem;
    line-height: 42px;
    margin-bottom: 4px;
  }
  p {
    line-height: 42px;
    margin: 0;
    a {
      font-weight: 600;
      font-size: 1rem;
    }
  }
}
.topbar {
  height: 100%;
  width: 98%;
}

.leftTitle {
  height: 100%;
  width: 49%;
  margin-top: 1%;
  margin-left: 1%;
  display: inline-block;
}
.chart {
  height: 100%;
  width: 99%;
  margin-top: 2%;
  background-color: #ffffff;
  margin-left: 1.5%;
}
.button-group {
  height: 100%;
  width: 49%;
  display: inline-block;
  text-align: right;
}
.range-picker {
  width: 35%;
  margin-right: 3%;
}
</style>
